import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class StoresService {
  fetchStores = params => {
    return fetch(config.config.endpointUrls.fetchStores(params), {
      method: 'GET'
    })
  }

  fetchStore = params => {
    return fetch(config.config.endpointUrls.fetchStore(params), {
      method: 'GET'
    })
  }

  createStore = fields => {
    return fetch(config.config.endpointUrls.createStore(), {
      method: 'POST',
      body: fields
    })
  }

  patchStore = ({ id, fields }) => {
    return fetch(config.config.endpointUrls.patchStore({ id }), {
      method: 'PATCH',
      body: fields
    })
  }

  setStoreCalendars = ({ id, calendarIds }) => {
    return fetch(config.config.endpointUrls.setStoreCalendars({ id }), {
      method: 'PUT',
      body: { calendarIds }
    })
  }
}

export default new StoresService()



// WEBPACK FOOTER //
// ../src/services/storesService/storesService.js